import { createRoutine } from 'redux-saga-routines';

import { MaintenanceType } from 'types/drupal';

export const drupalFetchCSRFRoutine = createRoutine('DRUPAL/FETCH_CSRF');
export const drupalMaintenanceRoutine = createRoutine<MaintenanceType>('DRUPAL/MAINTENANCE');
